// src/components/SplashScreen.jsx

import React, { useEffect } from "react";
import { motion } from "framer-motion";

import TopS from "../assets/splash/top_s.png";
import BottomS from "../assets/splash/bottom_s.png";
import { SplashScreen as NativeSplash } from "@capacitor/splash-screen";
import { Capacitor } from "@capacitor/core";

const BRAND_ORANGE = "#FF7417";

// Final spacing between the two tightly-cropped S pieces
const TOP_FINAL_Y = "-10%";
const BOTTOM_FINAL_Y = "10%";

// Animation timing
const LOGO_DURATION = 2.2;
const BOTTOM_DELAY = 0.04;

// Logo finishes around 1.0s.
// Strike waits ~0.4s, then fades in.
const STRIKE_DELAY = 2.15;
const STRIKE_DURATION = 0.3;

export default function SplashScreen() {
  useEffect(() => {
    const previousBodyBackground = document.body.style.backgroundColor;
    const previousHtmlBackground =
      document.documentElement.style.backgroundColor;

    document.body.style.backgroundColor = BRAND_ORANGE;
    document.documentElement.style.backgroundColor = BRAND_ORANGE;

    if (Capacitor.isNativePlatform()) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          NativeSplash.hide({ fadeOutDuration: 0 }).catch(() => {});
        });
      });
    }

    return () => {
      document.body.style.backgroundColor = previousBodyBackground;
      document.documentElement.style.backgroundColor =
        previousHtmlBackground;
    };
  }, []);

  return (
    <div
      className="
        fixed inset-0
        flex items-center justify-center
        overflow-hidden
        select-none
        z-[9999]
      "
      style={{
        backgroundColor: BRAND_ORANGE,
      }}
    >
      {/* LOGO ASSEMBLY */}
      <div
        className="
          relative
          w-[min(92vw,500px)]
          aspect-square
        "
      >
        {/* BOTTOM S — rises from below */}
        <motion.img
          src={BottomS}
          alt=""
          aria-hidden="true"
          draggable={false}
          className="
            absolute inset-0
            w-full h-full
            object-contain
            pointer-events-none
          "
          initial={{
            y: "150vh",
            opacity: 1,
          }}
          animate={{
            y: BOTTOM_FINAL_Y,
            opacity: 1,
          }}
          transition={{
            duration: LOGO_DURATION,
            delay: BOTTOM_DELAY,
            ease: [0.22, 0.75, 0.25, 1],
          }}
        />

        {/* TOP S — drops from above */}
        <motion.img
          src={TopS}
          alt="SatStacker"
          draggable={false}
          className="
            absolute inset-0
            w-full h-full
            object-contain
            pointer-events-none
          "
          initial={{
            y: "-150vh",
            opacity: 1,
          }}
          animate={{
            y: TOP_FINAL_Y,
            opacity: 1,
          }}
          transition={{
            duration: LOGO_DURATION,
            ease: [0.22, 0.75, 0.25, 1],
          }}
          style={{
            filter: `
              drop-shadow(6px 0 0 ${BRAND_ORANGE})
              drop-shadow(-6px 0 0 ${BRAND_ORANGE})
              drop-shadow(0 6px 0 ${BRAND_ORANGE})
              drop-shadow(0 -6px 0 ${BRAND_ORANGE})

              drop-shadow(4px 4px 0 ${BRAND_ORANGE})
              drop-shadow(-4px 4px 0 ${BRAND_ORANGE})
              drop-shadow(4px -4px 0 ${BRAND_ORANGE})
              drop-shadow(-4px -4px 0 ${BRAND_ORANGE})
            `,
          }}
        />
      </div>

      {/* POWERED BY STRIKE */}
      <motion.div
        className="
          absolute
          bottom-[calc(env(safe-area-inset-bottom,0px)+32px)]
          left-0 right-0
          flex flex-col
          items-center
          gap-1
        "
        initial={{
          opacity: 0,
          y: 8,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          delay: STRIKE_DELAY,
          duration: STRIKE_DURATION,
          ease: "easeOut",
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: "0.16em",
            color: "rgba(255,255,255,0.72)",
            textTransform: "uppercase",
          }}
        >
          Powered by
        </span>

        <span
          style={{
            fontSize: 19,
            fontWeight: 700,
            letterSpacing: "0.1em",
            color: "#ffffff",
            textTransform: "uppercase",
          }}
        >
          Strike
        </span>
      </motion.div>
    </div>
  );
}